import { render, staticRenderFns } from "./VaccinationByPharmacy.vue?vue&type=template&id=620da8cd&"
import script from "./VaccinationByPharmacy.vue?vue&type=script&lang=js&"
export * from "./VaccinationByPharmacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports